import { render } from "./ModuleCopyVideo.vue?vue&type=template&id=6ec0272e"
import script from "./ModuleCopyVideo.vue?vue&type=script&lang=js"
export * from "./ModuleCopyVideo.vue?vue&type=script&lang=js"

import "./ModuleCopyVideo.vue?vue&type=style&index=0&id=6ec0272e&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__